import { render, staticRenderFns } from "./imagesWithLightbox.vue?vue&type=template&id=42543daa"
import script from "./imagesWithLightbox.vue?vue&type=script&lang=js"
export * from "./imagesWithLightbox.vue?vue&type=script&lang=js"
import style0 from "./imagesWithLightbox.vue?vue&type=style&index=0&id=42543daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports